/**
 * Users Page
 * Main page for user management
 */
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { UserList, UserForm, UserDetail } from '../../components/Users';

const UsersPage = () => {
  return (
    <Routes>
      <Route index element={<UserList />} />
      <Route path="create" element={<UserForm />} />
      <Route path=":id" element={<UserDetail />} />
      <Route path=":id/edit" element={<UserForm />} />
    </Routes>
  );
};

export default UsersPage;





